import React from 'react'
import styled from 'styled-components'
import breakpoint from 'styled-components-breakpoint'
import ReactSVG from 'react-svg'

// TODO: Prop-types

const Transition = '.3s ease-in-out'

const Button = ({ link, texto, icon, className, smaller, amex }) => (
  <ButtonWrapper
    href={link}
    smaller={smaller}
    amex={amex}
    className={className}
  >
    <IconContainer smaller={smaller}>{icon}</IconContainer>
    {texto}
    <InnerButton amex={amex}>Solicitar</InnerButton>
  </ButtonWrapper>
)

const Icons = {
  whatsapp: (
    <ReactSVG
      path={`/images/iconos/contacto-whatsapp.svg`}
      alt={`Solicitala por WhatsApp`}
      svgStyle={{ height: 25, width: 'auto' }}
    />
  ),
  formulario: (
    <ReactSVG
      path={`/images/iconos/contacto-formulario.svg`}
      alt={`Solicitala por Formulario`}
      svgStyle={{ height: 25, width: 'auto' }}
    />
  ),
}

class MultiCanalidad extends React.Component {
  render() {
    const { smaller, formulario, amex } = this.props
    const { whatsapp, form } = this.props.multicanalidad
    const formLink = formulario ? formulario : form
    const Botones = {
      whatsapp: (
        <Button
          link="https://www.baccredomatic.com/es-cr/tarjetas/credito/whatsapp/solicitud"
          texto="WhatsApp"
          smaller={smaller}
          icon={Icons.whatsapp}
          amex={amex}
          className="multicanalidad-link-whatsapp"
        />
      ),
      form: (
        <Button
          link={formLink}
          texto="Solicitala Aquí"
          smaller={smaller}
          icon={Icons.formulario}
          amex={amex}
          className="multicanalidad-link-form"
        />
      ),
    }

    return (
      <Container>
        {form && Botones.form}
        {whatsapp && Botones.whatsapp}
        
      </Container>
    )
  }
}

export default MultiCanalidad

const Container = styled.div`
  border: solid 1px ${props => props.theme.colors.grisMedio};
  border-radius: 5px;
  display: flex;
  overflow: hidden;
  max-width: 100%;

  & > a {
    width: 100%;
    max-width: 100%;
  }
`
const ButtonWrapper = styled.a`
  display: flex;
  flex: 1 1;
  justify-items: center;
  align-content: center;
  text-align: center;
  padding: ${props => (props.smaller ? '.6em .5em .5em' : '1em')};
  border-right: solid 1px ${props => props.theme.colors.grisMedio};
  text-decoration: none !important;
  color: #000;
  font-weight: bold;
  font-size: 14px;
  flex-direction: column;
  background: #fff;

  ${breakpoint('tablet')`
    padding: ${props => (props.smaller ? '.8em .5em .5em' : '1.3em')};
    font-size: 14px;
  `}

  &:last-of-type {
    border-right: 0;
  }

  &:hover {
    color:black;
    svg {
      transform: scale(1.1);
    }
    path,
    rect,
    polygon {
      fill: ${props =>
        props.amex ? props.theme.colors.amexBlue : props.theme.colors.rojoBac};
    }
  }
`

const IconContainer = styled.div`
  margin-bottom: ${props => (props.smaller ? '.2' : '.5')}em;
  width: 40px;
  margin: 0 auto;

  ${breakpoint('tablet')`
    width: auto;
  `}

  svg {
    height: ${props => (props.smaller ? '20' : '30')}px;
    transition: transform ${Transition};

    ${breakpoint('tablet')`
      height: ${props => (props.smaller ? '25' : '40')}px;
    `}
  }

  path,
  rect,
  polygon {
    transition: fill ${Transition};
  }
`

const InnerButton = styled.div`
  background: ${props =>
    props.amex ? props.theme.colors.amexBlue : props.theme.colors.rojoBac};
  color: #fff;
  font-weight: 400;
  text-decoration: none;
  text-align: center;
  padding: 3px;
  font-size: 13px;
  font-weight: 400;
  transition: transform ${Transition};
  -webkit-font-smoothing: antialiased;
  margin-top: 0.5em;
`
